// Prospect demo entry: /demo/:token redeems an admin-issued expiring link.
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { api } from '@/lib/api';
import { useApp } from '@/lib/store';

export default function DemoEntry() {
  const { token } = useParams();
  const { signIn } = useApp();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const redeem = async () => {
      try {
        const res = await api.redeemDemo(token);
        signIn(res.data.token, res.data.user);
        navigate('/', { replace: true });
      } catch (err) {
        setError(err.response?.data?.detail || 'This demo link is not valid.');
      }
    };
    redeem();
  }, [token, signIn, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-muted-foreground" data-testid="demo-status">
        {error || 'Opening your demo…'}
      </p>
    </div>
  );
}
